export const environment = {
  production: false,
  name: 'staging',

  apiUrl: 'https://yoshu-api-975978410660.europe-west1.run.app/v1',
  socketUrl: 'https://yoshu-api-975978410660.europe-west1.run.app',

  tenantId: 'forvia-haa3f',
  firebase: {
    apiKey: 'AIzaSyCDf1EdCj7sevm4-jQB13StpRD6sUO6ssg',
    authDomain: 'yoshu-authentification-staging.firebaseapp.com',
    projectId: 'yoshu-authentification-staging',
    storageBucket: 'yoshu-authentification-staging.firebasestorage.app',
    messagingSenderId: '975978410660',
    appId: '1:975978410660:web:71d27eb6d8ef2f40772c31',
    measurementId: 'G-CTJF15NYNP'
  },

  posthog: {
    apiKey: 'sample-posthog-api-key',
    apiHost: 'https://eu.posthog.com'
  },

  features: {
    'module.free-mode': true,
    'free-chat.response-feedback': true
  }
}
